import { httpConstants } from "../constants";
import { httpService } from "../utility/httpService";

export default {
    addCategory,
    addParentCategory,
    updateCategory,
    updateParentCategory,
    getCategoryList,
    getParentCategoryList,
    getHomeAPIData,
}

async function addCategory(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.ADD_CATEGORY ;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}
async function addParentCategory(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.ADD_PARENT_CATEGORY ;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}
async function updateCategory(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.ADD_CATEGORY ;
    return httpService(httpConstants.METHOD_TYPE.PUT, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}
async function updateParentCategory(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.ADD_PARENT_CATEGORY ;
    return httpService(httpConstants.METHOD_TYPE.PUT, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function getCategoryList() {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.CATEGORY_LIST ;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), {}, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}
async function getParentCategoryList() {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.PARENT_CATEGORY_LIST ;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), {}, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function getHomeAPIData() {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.HOME_API ;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), {}, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}


function getHeaders() {
    return { 'Content-Type': httpConstants.CONTENT_TYPE.APPLICATION_JSON, 'skip': true }
}
